import { ResourceType } from '@repo/api-gw-sdk';

export const HighFrequencySupportedResourceTypes: ResourceType[] = [
  ResourceType.AwsDynamoDb,
  ResourceType.AwsS3,
  ResourceType.GcpCloudStorageBucket,
];
